import { QueryClient } from '@tanstack/react-query';

/**
 * Shared app-wide QueryClient. Lives in its own module so non-React helpers
 * (e.g. src/lib/finale.ts) can invalidate queries without importing App.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Keep data fresh but don't refetch too aggressively
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 60 * 24, // 24 hours (formerly cacheTime)
      // Retry with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      // Don't refetch on window focus when offline
      refetchOnWindowFocus: () => navigator.onLine,
      // Network mode for offline support
      networkMode: 'offlineFirst',
    },
    mutations: {
      retry: 2,
      retryDelay: 1000,
      networkMode: 'offlineFirst',
    },
  },
});
